<template>
     <div class="whAll">
          <router-view></router-view>
     </div>
     
</template> 
<script>
    export default {
        
        data () {
            return {  
                 
            };
            
        }, 
        computed: {
        
        },
        methods: {
             
        },
        mounted: function(){
            
        }
    }
</script>  
<style scoped>
    
</style>